import { Sparkles } from "lucide-react";

export default function FoundingBadge({ size = "sm", "data-testid": testId = "founding-badge" }) {
  const sizes = {
    xs: "text-[10px] px-1.5 py-0.5 gap-0.5",
    sm: "text-xs px-2 py-1 gap-1",
    md: "text-sm px-3 py-1.5 gap-1.5",
  };
  const iconSize = { xs: 10, sm: 12, md: 14 }[size] || 12;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center font-semibold uppercase tracking-wider rounded-full bg-gradient-to-r from-[var(--ff-primary)] to-[var(--ff-primary-hover)] text-white ${sizes[size] || sizes.sm}`}
      title="Founding Member — joined during the pre-launch presale"
    >
      <Sparkles size={iconSize} />
      Founding
    </span>
  );
}
